import { useState, useEffect } from "react";

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerID = setInterval(() => {
      setTime(new Date());
    }, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(timerID);
  }, []);

  return <div style={{ fontSize: "1em" }}>{time.toLocaleTimeString()}</div>;
};

export default Clock;
